<template>
    <div class="question">
        <form id="myForm" @submit.prevent>
            <div class="question-item">
                <div class="question-number">
                    {{ __t('Запитання') }} <strong>{{ currentQuestion + 1 }}</strong> {{ __t('з') }} <strong>{{
                        q_length
                    }}</strong>
                </div>
                <div class="question-text">
                    {{ question.title }}
                </div>
                <div class="question-form">
                    <div class="form-field">
                        <input
                            type="text"
                            ref="inputValue"
                            :pattern="question.mask && question.mask.slug === 'phone' ? '[0-9]*' : ''"
                            :inputmode="question.mask && question.mask.slug === 'phone' ? 'numeric' : ''"
                            :class="question.mask ? question.mask.slug : ''"
                            :name="question.id"
                            :input_name="question.input_name"
                            @input="checkInput">
                    </div>
                </div>

            </div>
            <a href="javascript:;" class="back-btn" :class="{hidden: currentQuestion == 0}"
               @click="setPrevQuestion">{{ __t('Назад') }}</a>
            <button @click="saveData" :class="{disabled: button_disabled}">
                <span v-if="currentQuestion+1 == q_length">{{ __t('Відправити') }}</span>
                <span v-if="currentQuestion+1 != q_length">{{ __t('Далі') }}</span>
            </button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'Input',
    props: ['q_length', 'question', 'formData', 'currentQuestion'],
    data() {
        return {
            button_disabled: true
        }
    },
    mounted() {
        /*input: event => this.$emit('input', event.target.value)*/

        $('input.phone').mask('+38(YSS) SSS-SS-SS', {
            placeholder: "+38(0__) ___-__-__", 'translation': {
                S: {pattern: /[0-9]/},
                Y: {pattern: /[0]/}
            }, clearIfNotMatch: true
        });

        $('input.ten_digits').mask('SSSSSSSSSS', {
            'translation': {
                S: {pattern: /[0-9]/},
            }
        });
        $('input.six_digits').mask('SSSSSS', {
            'translation': {
                S: {pattern: /[0-9]/},
            }
        });
    },
    methods: {
        __t(phrase) {
            return window.__t(phrase);
        },
        saveData() {

            var values = {};
            values["value"] = this.$refs.inputValue.value;
            values["type"] = this.question.type;
            values["name"] = this.question.input_name;

            var rv = {};

            rv[this.question.id] = values;

            if (rv.hasOwnProperty(this.question.id)) {
                this.$emit('saveData', rv)
            }

        },
        checkInput() {
            let $input = $(this.$refs.inputValue);

            if ($input.hasClass('only_letters')) {
                let val = $input.val().replace(/[^а-яА-ЯІіЇїЄєЁёҐґa-zA-Z\s\'\-]/g, '');
                $input.val(val);
            }
            if ($input.hasClass('only_numbers')) {
                let val = $input.val().replace(/[^0-9\'\-]/g, '');
                $input.val(val);
            }
            if ($input.hasClass('email')) {
                let val = $input.val().replace(/[^a-zA-Z\-\d\@\.\_]/g, '');
                $input.val(val);
                let charCode = e.which || e.keyCode;

                if (charCode === 32) {
                    e.preventDefault();
                }
            }

            if ($input.hasClass('ten_digits') && $input.val().length < 10) {
                $input.addClass('error');
            } else if ($input.hasClass('six_digits') && $input.val().length < 6) {
                $input.addClass('error');
            } else if ($input.hasClass('phone') && $input.val().length < 18) {
                $input.addClass('error');
            } else if ($input.hasClass('only_letters') && $input.val() === '') {
                $input.addClass('error');
            } else if ($input.hasClass('only_numbers') && $input.val() === '') {
                $input.addClass('error');
            } else {
                $input.removeClass('error');
            }

            if ($input.val() !== '' && !$input.hasClass('error')) {
                this.button_disabled = false;
            } else {
                this.button_disabled = true;
            }
        },
        setPrevQuestion() {
            this.$emit('setPrevQuestion')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/type_input.vue